import { z } from 'zod';
export const PluginHandlerErrorResponse = z.object({ errorMessage: z.string() });
//# sourceMappingURL=plugins-handlers.js.map